import type { OnInit } from '@angular/core';
import {
  ChangeDetectionStrategy,
  Component,
  Input,
  inject,
} from '@angular/core';
import { ContainerSize } from '@freelancer/ui/container';
import { UI_CONFIG } from '@freelancer/ui/ui.config';
import { UiConfig } from '@freelancer/ui/ui.interface';

@Component({
  standalone: false,
  selector: 'app-footer',
  template: `
    <ng-container [ngSwitch]="theme">
      <app-footer-deloitte
        *ngSwitchCase="'deloitte'"
        [containerSize]="containerSize"
      ></app-footer-deloitte>
      <app-footer-freightlancer
        *ngSwitchCase="'freightlancer'"
        [containerSize]="containerSize"
      ></app-footer-freightlancer>
      <app-footer-freelancer
        *ngSwitchDefault
        [containerSize]="containerSize"
      ></app-footer-freelancer>
    </ng-container>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FooterComponent implements OnInit {
  private uiConfig = inject<UiConfig>(UI_CONFIG);

  theme?: string;

  @Input() containerSize: ContainerSize;

  ngOnInit(): void {
    this.theme = this.uiConfig.theme;
  }
}
